import { render, staticRenderFns } from "./coursecard.vue?vue&type=template&id=0c032937&scoped=true"
import script from "./coursecard.vue?vue&type=script&lang=js"
export * from "./coursecard.vue?vue&type=script&lang=js"
import style0 from "./coursecard.vue?vue&type=style&index=0&id=0c032937&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c032937",
  null
  
)

export default component.exports